import { getAuthToken } from "./parseCookie";
import axios from "axios";

export const requestHeaders = () => {
  return {};
};

// @docs https://shopify.dev/apps/auth/oauth/session-tokens/axios
export const apiCall = axios.create();
// Intercept all requests on this Axios instance
apiCall.interceptors.request.use(function (config) {
  config.headers["Accept"] = "application/json";
  const token = getAuthToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// Intercept response. If token is expired, redirect
apiCall.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.error("API Error!", error);

    // If it's a network error, redirect to that page
    if (error.code === "ERR_NETWORK") {
      // @todo send an error report here

      window.location.href = "/error/network";
    }

    // If error is 401 & we're not already on the login page, then  redirect to login page
    if (
      error.response.status === 401 &&
      window.location.pathname !== "/login"
    ) {
      console.log("Redirecting to login page");
      window.location.assign("/login?exp");
    }

    return Promise.reject(error);
  }
);

const request = () => {
  const authToken = getAuthToken();
  const authHeaders = {
    Accept: "application/json",
    Authorization: `Bearer ${authToken}`,
  };

  return {
    get: (url, options) =>
      apiCall
        .get(url, {
          headers: { ...authHeaders },
          ...options,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => error),
    post: (url, payload, options) =>
      apiCall
        .post(url, payload, {
          headers: { ...authHeaders },
          ...options,
        })
        .then((response) => response.data)
        .catch((error) => error),
    put: (url, payload, options) =>
      apiCall
        .put(url, payload, {
          headers: { ...authHeaders },
          ...options,
        })
        .then((response) => response.data)
        .catch((error) => error),
  };
};

export default request;
